import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-inner">
        
        {/* Main Grid Layout */}
        <div className="footer-main-grid">
          
          {/* Column 1: Brand & Description (Spans 2 Rows on Desktop) */}
          <div className="footer-brand-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/Group%20494.svg`}
              alt="DigitMoney"
              className="footer-logo-img"
            />
            
            <h3 className="footer-tagline">Loan discovery, simplified.</h3>
            
            <p className="footer-desc">
              DigitMoney helps you explore gold<br/>
              loan options from trusted, RBI-<br/>
              regulated lending partners.
            </p>
            <p className="footer-desc">
              DigitMoney is a loan comparison<br/>
              platform. We are not a lender. Loans<br/>
              are subject to lender approval.
            </p>

            <div className="footer-grievance">
              <p>Grievance Redressal Officers<br/>
              Ammy Pinheiro: <a href="mailto:grievance@digitmoney.in">grievance@digitmoney.in</a></p>
            </div>
          </div>

          {/* Row 1, Column 2: PRODUCTS */}
          <div className="footer-link-col col-products">
            <h4 className="footer-col-title">PRODUCTS</h4>
            <ul className="footer-list">
              <li><a href="#">Personal Loan</a></li>
              <li><a href="#">Business Loan</a></li>
              <li><a href="#">Gold Loan</a></li>
              <li><a href="#">PayOff</a></li>
            </ul>
          </div>

          {/* Row 1, Column 3: COMPANY */}
          <div className="footer-link-col col-company">
            <h4 className="footer-col-title">COMPANY</h4>
            <ul className="footer-list">
              <li><a href="https://digitmoney.in/">About</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Press</a></li>
              <li><a href="https://digitmoney.in/lending-partners">Partners</a></li>
            </ul>
          </div>

          {/* Row 1, Column 4: RESOURCES */}
          <div className="footer-link-col col-resources">
            <h4 className="footer-col-title">RESOURCES</h4>
            <ul className="footer-list">
              <li><a href="#">EMI Calculator</a></li>
              <li><a href="#">Eligibility</a></li>
              <li><a href="#faqs">FAQs</a></li>
              <li><a href="#">Blog</a></li>
            </ul>
          </div>

          {/* Row 1, Column 5: LEGAL */}
          <div className="footer-link-col col-legal">
            <h4 className="footer-col-title">LEGAL</h4>
            <ul className="footer-list">
              <li><a href="https://digitmoney.in/privacy-policy">Privacy Policy</a></li>
              <li><a href="https://digitmoney.in/terms">Terms of Use</a></li>
              <li><a href="#">Grievance</a></li>
              <li><a href="#">RBI Sachet</a></li>
            </ul>
          </div>

          {/* Row 2, Columns 2 & 3: Social Media (Join Us) */}
          <div className="footer-join-us">
            <h4 className="footer-join-title">Join Us</h4>
            <div className="social-icons-wrapper">
              <a href="https://www.facebook.com/DigitMoneyTechnologies" className="social-icon">
                <img src="/assets/img/facebookIcon.svg" alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/digitmoney.india" className="social-icon">
                <img src="/assets/img/InstaIcon.svg" alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com/company/digitmoney" className="social-icon">
                <img src="/assets/img/LinkedInIcon.svg" alt="LinkedIn" />
              </a>
              <a href="https://www.youtube.com/@DigitMoneyIndia" className="social-icon">
                <img src="/assets/img/youtubeIcon.svg" alt="YouTube" />
              </a>
              <a href="https://twitter.com/DigitMoneyIndia" className="social-icon">
                <img src="/assets/img/twitterIcon.svg" alt="X" />
              </a>
              <a href="https://api.whatsapp.com/send/?phone=9076324177&type=phone_number&app_absent=0" className="social-icon">
                <img src="/assets/img/whatsappIcon.svg" alt="WhatsApp" />
              </a>
            </div>
          </div>

        </div>

        {/* Bottom Copyright Banner */}
        <div className="footer-bottom">
          <p>© 2025, DigitMoney Technologies Pvt. Ltd. All Rights Reserved.</p>
          <div className="footer-bottom-links">
            <a href="https://digitmoney.in/terms">Terms of Use</a>
            <a href="https://digitmoney.in/privacy-policy">Privacy Policy</a>
          </div>
        </div>

      </div>
    </footer>
  );
}